export default "__VITE_ASSET__Bp3ljKXr__$_?inline__"